<app-table *ngIf="list && list.table" [table]="list?.table"></app-table>
